// extracted by mini-css-extract-plugin
export default {"checkbox":"UheSN2","checkboxError":"vgWopH"};